import { cva } from "class-variance-authority";

export const dateRangeWrapperVariants = cva("flex items-center w-full", {
  variants: {
    size: {
      default: "gap-2",
      sm: "gap-2",
      xs: "gap-1",
    },
  },
  defaultVariants: { size: "default" },
});

export const dateRangeButtonVariants = cva("justify-start text-left font-normal flex-grow items-center", {
  variants: {
    size: {
      default: "gap-2",
      sm: "gap-1.5 text-xs",
      xs: "gap-1 h-6 px-1.5 text-[11px]",
    },
  },
  defaultVariants: { size: "default" },
});

export const dateRangeIconVariants = cva("", {
  variants: {
    size: {
      default: "size-4",
      sm: "size-4",
      xs: "size-3",
    },
  },
  defaultVariants: { size: "default" },
});

export const dateRangeClearVariants = cva("", {
  variants: {
    size: {
      default: "size-4",
      sm: "size-3",
      xs: "size-2.5",
    },
  },
  defaultVariants: { size: "default" },
});

export const DATE_FORMAT_BY_SIZE = {
  default: "MMM D, YYYY",
  sm: "MMM D",
  xs: "MMM D",
} as const;

export const BUTTON_SIZE_BY_SIZE = {
  default: "default",
  sm: "sm",
  xs: "sm",
} as const;
